<template>
  <div class="notification-container">
    <div class="notification-header">
      <div>
        <strong>
          <p>Stock threshold</p>
        </strong>
      </div>
      <div>
        <p>{{ stockThresholdLimit }} total units/product</p>
      </div>
      <div @click="showModel" class="pointer">
        <svg
          width="18"
          height="18"
          viewBox="0 0 14 14"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            width="14"
            height="14"
            fill="white"
            fill-opacity="0.01"
            style="mix-blend-mode:multiply"
          />
          <path d="M13.125 11.375H0.875V12.25H13.125V11.375Z" fill="#161616" />
          <path
            d="M11.1125 3.9375C11.4625 3.5875 11.4625 3.0625 11.1125 2.7125L9.5375 1.1375C9.1875 0.7875 8.6625 0.7875 8.3125 1.1375L1.75 7.7V10.5H4.55L11.1125 3.9375ZM8.925 1.75L10.5 3.325L9.1875 4.6375L7.6125 3.0625L8.925 1.75ZM2.625 9.625V8.05L7 3.675L8.575 5.25L4.2 9.625H2.625Z"
            fill="#161616"
          />
        </svg>
      </div>
    </div>

    <div style="display: flex; flex-direction:row; gap:12px; font-size:14px">
      <strong>Notification</strong>
      <label
        class="toggle-button"
        :class="{ '.toggle-button--disabled': isLoading }"
      >
        <input
          :aria-checked="notificationsEnabled"
          type="checkbox"
          :checked="notificationsEnabled"
          v-model="notificationsEnabled"
          @change="handleChange"
          :disabled="isLoading"
        />
        <span class="toggle-slider round"></span>
      </label>
    </div>
  </div>
</template>
<script>
import { mapState } from 'vuex'
export default {
  props: {
    showModel: {
      type: Function,
      required: true
    }
  },
  data() {
    return {
      notificationsEnabled: false,
      isLoading: false
    }
  },

  computed: {
    ...mapState({
      stockThresholdLimit: state => state.team.team.stockThresholdLimit,
      stockThresholdNotificationsEnabled: state =>
        state.team.team.stockThresholdNotificationsEnabled
    })
  },
  methods: {
    handleChange() {
      this.isLoading = true
      this.$store
        .dispatch(
          'inventory/toggleInventoryNotification',
          this.notificationsEnabled
        )
        .finally(() => {
          this.isLoading = false
        })
    }
  },
  created() {
    this.notificationsEnabled = this.stockThresholdNotificationsEnabled
  }
}
</script>
<style lang="css" scoped>
.notification-container {
  margin-top: 12px;
  display: flex;
  border-radius: 10px;
  padding: 10px;
  border: black 1px solid;
  flex-direction: row;
  justify-content: space-between;

  p {
    font-size: 14px;
  }
}
.notification-header {
  display: flex;
  margin-left: 10px;
  flex-direction: row;
  gap: 5px;
}

.pointer {
  cursor: pointer;
}
</style>
